module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Shop Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Shop Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-shop-devin",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('a', {
    attrs: {
      "href": "#featured",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("featured")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "role": "tabpanel",
      "id": "featured"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.publishers), function(option) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-6"
    }, [_c('div', {
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "product-item-thumbnail text-center mb-15"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
        "alt": "product image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-item-thumbnail-overlay"
    }, [_c('router-link', {
      staticClass: "btn btn-default pulse",
      attrs: {
        "to": ("" + ('/publisher/edit/' + option.uuid))
      }
    }, [_c('span', {
      staticClass: "ti-settings mr-0"
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 publishers-all"
    }, [_c('h5', {
      staticClass: "publishers-name"
    }, [_c('router-link', {
      attrs: {
        "to": ("" + ('/publisher-info/' + option.id + '/'))
      }
    }, [_vm._v(_vm._s(option.name))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 text-right"
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f2d06a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/pages/Profile.vue
// module id = 664
// module chunks = 2